

import { AxiosInstance } from "axios";

const confirmEmail = async (confirmationToken: string, axiosInstance: AxiosInstance) => {

        try {
            const response = await axiosInstance
                .put('/client/confirm-email', {
                    token: confirmationToken
                });
            return response.data;
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                return error.response.data.message;
            } else {
                return error.message;
            }
        }  
}

export {confirmEmail};